import { PayloadAction } from "@reduxjs/toolkit";
import { IThresholdCrossingDeviceFilterState } from "../types";
import { IGeoRegion } from "../../api/admin/types";
import { initialGeoRegion } from "../../../components/helpers";

export const setProfileKeyAction = (state: IThresholdCrossingDeviceFilterState, action: PayloadAction<string>) => {
   state.profileKey = action.payload;
};

export const setIsThresholdCrossingDeviceAssociationProgressAction = (state: IThresholdCrossingDeviceFilterState, action: PayloadAction<boolean>) => {
  state.isThresholdCrossingDeviceAssociationProgress = action.payload;
};

export const setSiteGroupAction = (state: IThresholdCrossingDeviceFilterState, action: PayloadAction<string>) => {
  state.siteGroup = action.payload;
};

export const setAddDeviceSiteGroupAction = (state: IThresholdCrossingDeviceFilterState, action: PayloadAction<string>) => {
  state.addDeviceSiteGroup = action.payload;
};

export const setGeoRegionAction = (state: IThresholdCrossingDeviceFilterState, action: PayloadAction<IGeoRegion>) => {
  state.geoRegion = action.payload;
};

export const setAddDeviceGeoRegionAction = (state: IThresholdCrossingDeviceFilterState, action: PayloadAction<IGeoRegion>) => {
  state.addDeviceGeoRegion = action.payload;
};

export const setIsAssociatedDevicesRemovedAction = (state: IThresholdCrossingDeviceFilterState, action: PayloadAction<boolean>) => {
  state.isAssociatedDevicesRemoved = action.payload;
};

export const resetFiltersAction = (state: IThresholdCrossingDeviceFilterState) => {
  state.geoRegion = initialGeoRegion;
  state.siteGroup = "";
};

export const resetAddDeviceFiltersAction = (state: IThresholdCrossingDeviceFilterState) => {
  state.addDeviceGeoRegion = initialGeoRegion;
  state.addDeviceSiteGroup = "";
};
export const setRuleNameAction = (state: IThresholdCrossingDeviceFilterState, action: PayloadAction<string>) => {
  state.ruleName = action.payload;
};

export const setNetworkTypeAction = (state: IThresholdCrossingDeviceFilterState, action: PayloadAction<string>) => {
  state.networkType = action.payload;
};

export const setThresholdStateAction = (state: IThresholdCrossingDeviceFilterState, action: PayloadAction<string>) => {
  state.thresholdState = action.payload;
};

export const resetThresholdAlertFiltersAction = (state: IThresholdCrossingDeviceFilterState) => {
  state.ruleName = undefined;
  state.networkType = "LTE";
  state.thresholdState = "ALL";
};

